import React, { Component, Fragment } from "react"
import actions from "./actions/root_action"
import { connect } from "react-redux"
import { withNamespaces } from "react-i18next"
import { compose } from "redux"
import Modal from '../../common/components/modal_dialog/modal_wrapper_component'
import "./main_container.scss"
import lozad from 'lozad'

const imgdir = '/assets/image/campaigns/overseas202210'

export class Main extends Component {
  async componentDidMount() {
    const observer = lozad()
    observer.observe()
  }

  render() {
    return (
      <React.Fragment>
        <div styleName="container">
          <h1>
            <img className="lozad" data-src={`${imgdir}/eyecatch-pc.png`} styleName="eye-catch" alt="海外宿泊施設に泊まって「楽天ポイント」10倍還元キャンペーン"/>
            <img className="lozad" data-src={`${imgdir}/eyecatch-sp.png`} styleName="eye-catch sp-only" alt="海外宿泊施設に泊まって「楽天ポイント」10倍還元キャンペーン"/>
          </h1>
          <div styleName="cpn-term">
            <div>
              <span>対象予約期間： </span>
              <span>2022年10月3日(月) ～ 2022年10月9日(日)</span>
            </div>
            <div>
              <span>対象宿泊期間： </span>
              <span>2022年10月3日(月) ～ 2023年1月31日(火)チェックアウト</span>
            </div>
          </div>
          <div styleName="block cpn-note">
            ※進呈するポイント（期間限定ポイント含）には上限や条件があります。詳しくはキャンペーン詳細をご確認ください。<br/>
            ※本キャンペーンは予告なく中止、変更する場合があります。予めご了承ください。
          </div>
          <div styleName="block">
            <div styleName="info">
              本キャンペーンは終了しました。
            </div>
          </div>
          <div styleName="block">
            <div styleName="information">
              <p>
                海外渡航の際は事前に各国・地域の入国制限、入国に際しての条件・行動制限についてご確認ください。<br/>
                <a id="overseas-search-link" href="https://www.anzen.mofa.go.jp/covid19/pdfhistory_world.html" target="_blank">外務省 海外安全ホームページ｜新型コロナウイルスに係る日本からの渡航者・日本人に対する各国・地域の入国制限措置及び入国に際しての条件・行動制限措置 （外部サイト）</a>
              </p>
              <br/>
              <p>
                日本へ入国・帰国する際の必要書類、検疫措置、入国後の待機など行動制限を含めた日本の水際対策についてもあわせてご確認ください。<br/>
                <a href="https://www.mhlw.go.jp/stf/seisakunitsuite/bunya/0000121431_00209.html" target="_blank">水際対策｜厚生労働省｜日本政府 （外部サイト）</a>
              </p>
            </div>
          </div>
          <div styleName="block">
            <a styleName="lp-link" href="/feature-overseas">海外の宿泊施設を探す</a>
            <div styleName="lp-link-caption">海外のヴィラ、ホテル、アパートメント、コンドミニアムを検索。<br/>海外旅行の新しい宿泊スタイルをご提案します。</div>
          </div>
          <section styleName="cpn-details">
            <h2 styleName="section-header">キャンペーン詳細</h2>
            <div styleName="block">
              <h3>キャンペーン内容</h3>
              <p>下記対象期間中に､楽天IDを用いて「Rakuten Oyado上にて日本国外の宿泊施設」をご予約し､実際にご宿泊された方に、もれなく楽天ポイントを通常(100円につき1ポイント)の10倍進呈いたします。</p>
              <div styleName="note">
                <span>ポイント10倍の楽天ポイント</span><br/>
                ※下記「対象施設」項目をご確認ください。<br/>
                ※楽天IDで決済された方は、通常ポイントを「1倍」、期間限定ポイントを「9倍」進呈いたします。<br/>
                ※楽天IDでログインし、楽天ID決済以外の方法で決済された方は、期間限定ポイントを合計料金の「10%」分進呈いたします。(合計料金＝宿泊料金+清掃料金+手配手数料)
              </div>

              <h3>キャンペーン対象者</h3>
              <p>楽天IDにて決済または、楽天IDでログインいただき、Rakuten Oyado上で日本国外の施設をご予約し実際にご宿泊された楽天会員様</p>

              <h3>対象サービス</h3>
              <p>Rakuten Oyado 日本国外の施設への宿泊</p>

              <h3>予約対象期間</h3>
              <p>2022年10月3日(月)00:00～2022年10月9日(日)23:59</p>
              <div styleName="note">※予約者と利用者が異なっても対象となります。キャンペーン還元ポイントは予約者の楽天IDに還元されます。</div>

              <h3>宿泊対象期間</h3>
              <p>2022年10月3日(月)チェックイン～2023年1月31日(火)チェックアウト</p>

              <h3>キャンペーン還元ポイント</h3>
              <h4>還元</h4>
              <div styleName="note">
                ※キャンペーン還元ポイントは、予約番号1件ごとに還元いたします。<br/>
                ※キャンペーン還元ポイントは、クーポン利用の場合はクーポン割引「後」の金額、ポイント利用の場合はポイント利用「前」の金額を元に計算されます。<br/>
                ※現地通貨でお支払いの予約については、Rakuten Oyado上で成立している料金(税抜)をもとに予約成立時の為替レートをもとに日本円換算したうえでキャンペーン還元ポイントが計算されます。<br/>
                ※ポイント還元時点でキャンセルとなっているご予約は対象外となります。<br/>
                ※キャンペーン還元ポイントは、Rakuten Oyado上で成立している料金(税抜)をもとに計算いたします。詳細は<a target="_blank" href="https://point.rakuten.co.jp/guidance/terms/">こちら</a>をご確認ください。<br/>
                ※期間限定ポイントについては<a target="_blank" href="https://point.rakuten.co.jp/guidance/terms/">こちら</a>をご参照ください。
              </div>
              <h4>還元時期</h4>
              <p>当該キャンペーンのキャンペーン還元ポイントは、通常ポイントとは別に2023年2月28日頃までに還元いたします。キャンペーン終了後、キャンペーン還元ポイントの還元まで期間がありますのでご注意ください。</p>
              <div styleName="note">※獲得したポイントは、楽天ポイント履歴画面でご確認ください。</div>
              <h4>上限</h4>
              <p>本キャンペーンにおける、1会員様あたりのキャンペーン還元ポイント上限は「10,000ポイント」になります。また、1ヶ月でご利用いただけるポイントは10万ポイントが上限ですので（ダイヤモンドランクの会員様は50万ポイントまで）、それを超えるポイントを獲得された場合、ポイントがご利用いただけないまま失効する事がございますので、あらかじめご了承ください。</p>

              <h3>注意事項</h3>
              <ul>
                <li>ご予約後、キャンセルまたは連絡なき不泊(NO-SHOW)、期間対象外となる予約変更は対象となりません。また、期間対象外となるご予約が成立し、その後インターネットを経由しない変更(現地施設でのお申し出など)で、期間内に該当するご予約になった場合も当該キャンペーンの対象とはなりません。</li>
                <li>宿泊期間対象外となるご予約が成立した後、対象期間内に予約変更（日程短縮等）をサイト上から実施してもシステム上、当該キャンペーンの対象外となります。</li>
                <li>アクセス集中やメンテナンスなどによりキャンペーン対象期間中のご利用ができなかった場合、キャンペーン対象外となります。詳細はこちらをご確認ください。</li>
                <li>キャンペーン還元ポイント獲得権利の譲渡はできません。</li>
                <li>本キャンペーンの対象予約が､別途エントリーいただいているRakuten Oyado主催の他キャンペーンにおいてもキャンペーン還元ポイントの対象となる場合は､いずれかのキャンペーンを優先し､優先されたキャンペーン還元ポイントのみを還元させていただく場合がございますので予めご了承ください｡</li>
                <li>キャンペーン内容は予告なく変更・終了することがあります。予めご了承ください。</li>
              </ul>
            </div>
          </section>
        </div>
        <Modal />
      </React.Fragment>
    )
  }
}

const mapStateToProps = state => {
  return {
    login: state.login,
    language: state.language,
    modal: state.modal
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    actions: actions(dispatch)
  }
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withNamespaces()
)(Main)
